import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleAccountIntegrationStepsGate = React.lazy(
  () => import("./GoogleAccountIntegrationSteps.gate")
);

const GoogleAccountIntegrationStepsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleAccountIntegrationStepsGate />
  </React.Suspense>
);

export default () => <GoogleAccountIntegrationStepsLoadable />;
